export default __webpack_public_path__ + "static/media/auth-image.97b04c17.jpg";